import { openUserModal } from '../State/userModal'

export default () => (dispatch) => {

  dispatch(openUserModal())
  
}
